import { ChartBar } from '../../../../components/chart';
import getFormatMessage from '../../../../locales/get-format-message';
import './style.scss';
import { DatePicker, Space } from 'antd';
import moment, { Moment } from 'moment';
import { useEffect, useState } from 'react';
import { getCostOverviewInfo } from '../../../../api';
import {
  ConsumeCostType,
  ICostOverview,
} from '../../../../model/billing-center';
import { GetformatMoney } from './component/fomat-money';

interface IProps {
  readonly studioId: string;
}
interface IAccumulatedAmounts {
  [key: number]: string;
}
export const BalanceOverviewComponent = (props: IProps) => {
  const { studioId } = props;
  const [dates, setDates] = useState<any>(null);
  // const [selectedRange, setSelectedRange] = useState<string[]>([]);
  const [costOverviewList, setCostOverviewList] = useState<ICostOverview[]>([]);
  const [selectedData, setSelectedData] = useState<ICostOverview | null>();
  const [selectedMonth, setSelectedMonth] = useState<string>('');
  const [lastAxisLabels, setLastAxisLabels] = useState<string[]>([]);
  const [lastSeriesData, setLastSeriesData] = useState<number[][]>([[], []]);
  // detail详情
  const [postpaidBill, setPostpaidBill] = useState<string>('');
  const [prepaidService, setPrepaidService] = useState<string>('');
  const [withdrawal, setWithdrawal] = useState<string>('');
  const [freeze, setFreeze] = useState<string>('');

  const getCostOverviewList = async () => {
    try {
      let formattedDates;
      if (dates && dates.length > 0) {
        formattedDates = dates.map((date: moment.MomentInput) =>
          moment(date).format('YYYY-MM')
        );
      } else {
        const currentMonth = moment().format('YYYY-MM');
        const previousYearMonth = moment(currentMonth)
          .subtract(11, 'month')
          .format('YYYY-MM');
        formattedDates = [previousYearMonth, currentMonth];
      }
      const res = await getCostOverviewInfo(
        studioId,
        formattedDates[0],
        formattedDates[1]
      );
      if (res) {
        const sortedRes = res.sort((a, b) => {
          const dateA = new Date(a.date);
          const dateB = new Date(b.date);
          return dateA.getTime() - dateB.getTime();
        });
        setCostOverviewList(sortedRes);
        const axisLabels = sortedRes.map((item) =>
          moment(item.date).format('YYYY-MM')
        );
        const incomeData = sortedRes.map((item) => parseFloat(item.income));
        const expensesData = sortedRes.map((item) => parseFloat(item.expenses));
        // console.log('axisLabels--x轴：', axisLabels);
        setLastAxisLabels(axisLabels);
        setLastSeriesData([incomeData, expensesData]);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleSelect = (value: string) => {
    // console.log('有无费用详情数据-value：', value);
    const selectedData = costOverviewList.find((data) =>
      data.date.includes(value)
    );
    if (value && selectedData) {
      setSelectedMonth(value);
    } else {
      setSelectedMonth('');
    }
    // console.log('有无费用详情数据111：', selectedData);
    if (selectedData) {
      setSelectedData(selectedData);
      const consumeTypes = [
        ConsumeCostType.POSTPAID, // 1
        ConsumeCostType.PREPAID, // 2
        ConsumeCostType.FREEZE, // 3
        ConsumeCostType.DRAW, // 4
      ];
      const accumulatedAmounts: IAccumulatedAmounts = consumeTypes.reduce(
        (acc, consumeType) => {
          const amount = selectedData.details.detail
            .filter((data) => data.consume_type === consumeType)
            .reduce((sum, data) => sum + parseFloat(data.amount), 0);

          return { ...acc, [consumeType]: amount };
        },
        {}
      );
      setPostpaidBill(accumulatedAmounts[ConsumeCostType.POSTPAID] || '');
      setPrepaidService(accumulatedAmounts[ConsumeCostType.PREPAID] || '');
      setFreeze(accumulatedAmounts[ConsumeCostType.FREEZE] || '');
      setWithdrawal(accumulatedAmounts[ConsumeCostType.DRAW] || '');
    } else {
      setSelectedData(null);
      setPostpaidBill('');
      setPrepaidService('');
      setFreeze('');
      setWithdrawal('');
    }
  };

  useEffect(() => {
    getCostOverviewList();
  }, [dates]);
  useEffect(() => {
    if (costOverviewList !== undefined && costOverviewList.length > 0) {
      const currentMonth = moment().format('YYYY-MM'); // 默认当月
      let selectMonth;
      if (costOverviewList.length === 1) {
        selectMonth = moment(costOverviewList[0].date).format('YYYY-MM');
      } else {
        selectMonth = currentMonth;
      }
      handleSelect(selectMonth); // 选择格式化后的月份
    }
  }, [costOverviewList]);

  const disabledDate = (current: Moment) => {
    if (!dates) {
      return false;
    }
    // 限制最多选择一年
    const tooLate = dates[0] && current.diff(dates[0], 'days') > 360;
    const tooEarly = dates[1] && dates[1].diff(current, 'days') > 360;
    return !!tooEarly || !!tooLate;
  };

  return (
    <>
      <div className="overview-over">
        <div className="overview-title">
          <span>{getFormatMessage('balance_overview')}</span>
          {/* 时间筛选控件 */}
          <Space direction="vertical">
            <div className="billing-date-picker">
              <DatePicker.RangePicker
                dropdownClassName="fee-data-dropdown"
                className="overview-date-picker"
                picker="month"
                allowClear={true}
                disabledDate={disabledDate}
                onCalendarChange={(val) => setDates(val)}
                monthCellRender={(date) => {
                  return `${moment(date).format('MM')}`; // 修改中文显示为数字
                }}
              />
            </div>
          </Space>
        </div>

        <ChartBar
          key={lastAxisLabels.join('-')} // 唯一
          className="overview-chart-bar"
          legend={[
            getFormatMessage('total_income'),
            getFormatMessage('total_spending'),
          ]}
          style={{ height: 300, width: '100%' }}
          xAxisLabel={lastAxisLabels}
          seriesData={lastSeriesData}
          onSelect={handleSelect}
          isHover={true}
          isSelect={true}
        />
      </div>
      <div className="bi-overview-bottom-details">
        <div className="details-line"></div>
        <div className="details-info">
          <div className="details-title">
            {selectedMonth}
            <span style={{ marginLeft: 6 }}>
              {getFormatMessage('fee_Details')}
            </span>
          </div>
          <div className="bi-details-content">
            <div className="balance-info-content">
              <div className="info-content-desc">
                <span></span>
                {getFormatMessage('month_end_balance')}
              </div>
              <div className="info-content-number">
                <GetformatMoney
                  className="details-info-money"
                  money={selectedData?.details.balance}
                />
              </div>
            </div>
            <div className="balance-info-content details-info-icon">
              <span className="info-icon">=</span>
            </div>
            <div className="balance-info-content">
              <div className="info-content-desc">
                <span className="info-content-desc-two"></span>
                {getFormatMessage('last_month_end_balance')}
              </div>
              <div className="info-content-number">
                <GetformatMoney
                  className="details-info-money"
                  money={selectedData?.details.last_balance}
                />
              </div>
            </div>
            <div className="balance-info-content details-info-icon">
              <span className="info-icon">+</span>
            </div>
            <div className="balance-info-content">
              <div className="info-content-desc">
                <span className="info-content-desc-three"></span>
                {getFormatMessage('this_month_end_balance')}
              </div>
              <div className="info-content-number">
                <GetformatMoney
                  className="details-info-money"
                  money={selectedData?.income}
                />
              </div>
            </div>
            <div className="balance-info-content details-info-icon">
              <span className="info-line"></span>
            </div>
            <div className="balance-info-content-spcail">
              <div className="detail-desc-left">
                <div className="info-content-desc">
                  <span className="info-content-desc-four"></span>
                  {getFormatMessage('month_this_balance')}
                </div>
                <div className="info-content-number">
                  <GetformatMoney
                    className="details-info-money"
                    money={selectedData?.expenses}
                  />
                </div>
              </div>
              <div className="right-line"></div>
              <div className="detail-desc-right">
                {postpaidBill && (
                  <div className="right-bill">
                    <span>{getFormatMessage('post_paid_bill')}</span>
                    <span>
                      <GetformatMoney
                        className="detail-money"
                        money={postpaidBill}
                      />
                    </span>
                  </div>
                )}
                {prepaidService && (
                  <div className="right-bill">
                    <span>{getFormatMessage('pre_paid_service')}</span>
                    <span>
                      <GetformatMoney
                        className="detail-money"
                        money={prepaidService}
                      />
                    </span>
                  </div>
                )}
                {withdrawal && (
                  <div className="right-bill">
                    <span>{getFormatMessage('withdrawal_fee_Details')}</span>
                    <span>
                      <GetformatMoney
                        className="detail-money"
                        money={withdrawal}
                      />
                    </span>
                  </div>
                )}
                {freeze && (
                  <div className="right-bill">
                    <span>{getFormatMessage('freeze_money')}</span>
                    <span>
                      <GetformatMoney className="detail-money" money={freeze} />
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
